import { Edit, Article } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import { hasRight } from '#app/Common/UserCommon';
import ContentViewComponent from '#app/Component/ContentViewComponent';
import IconAction from '#app/Component/IconAction';
import TableComponent from '#app/Component/TableComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { getRoutePathname } from '#app/Handler/RouteHandler';

function InventoryManagementDepositList() {
  const authenticationReducer = useSelector((state) => state.AuthenticationReducer);

  // List Deposits
  const columns = [
    {
      name: 'id',
      label: 'Référence',
      options: { filter: true, sort: true },
    },
    {
      name: 'name',
      label: 'Nom',
      options: { filter: true, sort: true },
    },
    {
      name: 'openingTime',
      label: "Horaire d'ouverture",
      options: { filter: true, sort: true },
    },
    {
      name: 'closingTime',
      label: 'horaire de fermeture',
      options: { filter: true, sort: true },
    },
    {
      name: 'shopRegionText',
      label: 'Région boutique',
      options: { filter: true, sort: true },
    },
    {
      name: 'userRegionText',
      label: 'Utilisateur région',
      options: { filter: true, sort: true },
    },
    {
      name: 'userNationalText',
      label: 'Utilisateur national',
      options: { filter: true, sort: true },
    },
    {
      name: 'userLogistiqueText',
      label: 'Utilisateur logistique',
      options: { filter: true, sort: true },
    },
    {
      name: 'openCloseCode',
      label: 'Code ouverture/fermeture',
    },
    {
      name: 'action',
      label: 'Action',
      options: { filter: false, sort: false },
    },
  ];

  const getAction = (row) => {
    if (
      hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP') ||
      hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP_GET')
    ) {
      return (
        <>
          {hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP') ||
          hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP_EDIT') ? (
            <IconAction title="Modifier" icon="edit" to={getRoutePathname('shop_management_shop', { id: row.id })} />
          ) : hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP_GET') ? (
            <IconAction title="Visualiser" icon="view" to={getRoutePathname('shop_management_shop', { id: row.id })} />
          ) : (
            <IconButton disabled={true}>
              <Edit style={{ color: '#17a2b8' }} />
            </IconButton>
          )}
        </>
      );
    } else {
      return (
        <>
          {hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP_EDIT') ? (
            <IconButton style={{ cursor: 'no-drop' }}>
              <Edit />
            </IconButton>
          ) : (
            <IconButton style={{ cursor: 'no-drop' }}>
              <Article />
            </IconButton>
          )}
        </>
      );
    }
  };

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des boutiques', context: 'Gestion boutique' }}>
      <TableComponent
        id={'api_shop_management_shop_list'}
        title={'Boutiques'}
        columns={columns}
        actionFirst={
          hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP') ||
          hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP_ADD')
            ? {
                label: 'Ajouter une boutique',
                link: getRoutePathname('shop_management_shop', { id: 'add' }),
              }
            : false
        }
        promiseData={(resolve) => {
          ApiHandler.get({ route: 'api_shop_management_shop_list' }, (response) => {
            const data = response.data;
            for (const index in data) {
              data[index].action = getAction(data[index]);
              data[index].openingTime = data[index].openingTime ? data[index].openingTime : '-';
              data[index].closingTime = data[index].closingTime ? data[index].closingTime : '-';
              data[index].shopRegionText = data[index].shopRegionText ? data[index].shopRegionText : '-';
              data[index].userRegionText = data[index].userRegionText ? data[index].userRegionText : '-';
              data[index].userNationalText = data[index].userNationalText ? data[index].userNationalText : '-';
              data[index].userLogistiqueText = data[index].userLogistiqueText ? data[index].userLogistiqueText : '-';
              data[index].openCloseCode = data[index].openCloseCode ? data[index].openCloseCode : '-';
            }
            resolve(data);
          });
        }}
      />
      <br />
      <br />
    </ContentViewComponent>
  );
}

export default InventoryManagementDepositList;
